const ServiceConstants = {
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
    API_URL: process.env.REACT_APP_BACKEND_URL + '/api'
}
export default ServiceConstants;